import React from 'react';
import styled from 'styled-components';
import {Stack, px, py} from '@nib/layout';
import {ResponsiveSpaceProp} from '../constants';

const Relative = styled.div`
  position: relative;
  ${py(6)};
  ${px(5)};
`;

export const Overlay = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

export interface ProductCardBodyProps {
  children: React.ReactNode;
  isUnavailable: boolean;
  space?: ResponsiveSpaceProp;
  [key: string]: unknown; // other props
}

const ProductCardBody: React.FC<ProductCardBodyProps> = ({children, space = 6, isUnavailable, ...otherProps}) => {
  return (
    <Relative {...otherProps}>
      <Stack space={space}>{children}</Stack>
      {isUnavailable && <Overlay />}
    </Relative>
  );
};

export default ProductCardBody;
